<template>
  <div>
    <div class="columns is-mobile">
      <div class="column is-8 is-hidden-mobile"/>
      <div class="column is-narrow">
        <div class="title is-5">
          {{ Catalog.Total.Label }}
        </div>
      </div>
      <div class="column">
        <div class="has-text-right">
          <kst-value class="title is-5 pr-3"
            field="Total" :data="details" :catalog="Catalog"
          />
        </div>
      </div>
    </div>

    <div class="columns is-mobile">
      <div class="column is-8 is-hidden-mobile"/>
      <div class="column pb-0 is-narrow">
        <div class="title is-5">
          {{ Catalog.PaymentTypeCash.Label }}
        </div>
      </div>
      <div class="column pb-0 ks-border-t-black">
        <div class="has-text-right">
          <kst-value class="title is-5 pr-3"
            field="PaymentTypeCash" :data="details" :catalog="Catalog"
          />
        </div>
      </div>
    </div>

    <div class="columns is-mobile">
      <div class="column is-8 is-hidden-mobile"/>
      <div class="column pb-0 is-narrow">
        <div class="title is-5">
          {{ Catalog.CashReceived.Label }}
        </div>
      </div>
      <div class="column pb-0">
        <div class="has-text-right">
          <kst-value class="title is-5 pr-3"
            field="CashReceived" :data="details" :catalog="Catalog"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Catalog from "../SlrcCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>